import { render, staticRenderFns } from "./LiveMessageInput.vue?vue&type=template&id=7a7731d0"
import script from "./LiveMessageInput.vue?vue&type=script&lang=ts"
export * from "./LiveMessageInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports